











import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

@Component({
    computed: {
        ...mapGetters({ pageTitle: 'getTitle' }),
    },
})
export default class LoginLayout extends Vue {
}
